import script from "./ViewCommandeEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewCommandeEdit.vue?vue&type=script&setup=true&lang=ts"

import "./ViewCommandeEdit.vue?vue&type=style&index=0&id=3d5ec064&lang=scss"

const __exports__ = script;

export default __exports__